import React from 'react'
// import { LocaleProvider } from 'antd'
import { ConfigProvider } from 'antd'
import { IntlProvider, addLocaleData } from 'react-intl'
import { connect } from 'react-redux'
import english from 'locales/en-US'
import french from 'locales/fr-FR'
import russian from 'locales/ru-RU'
import chinese from 'locales/zh-CN'
import Spanish from 'locales/es-ES'
import Catalan from 'locales/ca-ES'
import Portuguese from 'locales/pt-PT'
import Mexican from 'locales/es-MX'
import German from 'locales/de-De'

addLocaleData(english.localeData)
addLocaleData(french.localeData)
addLocaleData(russian.localeData)
addLocaleData(chinese.localeData)
addLocaleData(Spanish.localeData)
addLocaleData(Catalan.localeData)
addLocaleData(Portuguese.localeData)
addLocaleData(Mexican.localeData)
addLocaleData(German.localeData)

const locales = {
  'en-US': english,
  'fr-FR': french,
  'ru-RU': russian,
  'zh-CN': chinese,
  'es-ES': Spanish,
  'ca-ES': Catalan,
  'pt-PT': Portuguese,
  'es-MX': Mexican,
  'de-DE': German,
}

@connect(({ settings }) => ({ settings }))
class Localization extends React.Component {
  render() {
    const {
      children,
      settings: { locale },
    } = this.props

    const {
      history: { location },
    } = children.props
    let isConsumerPage = false
    if (location && location.pathname) {
      isConsumerPage = location.pathname.includes('enduser')
    }

    const currentLocale = locales[!isConsumerPage ? 'en-US' : locale]

    return (
      // <LocaleProvider locale={currentLocale.antdData}>
      //   <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
      //     {children}
      //   </IntlProvider>
      // </LocaleProvider>
      <ConfigProvider locale={currentLocale.antdData}>
        <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
          {children}
        </IntlProvider>
      </ConfigProvider>
    )
  }
}

export default Localization
